module.exports = __webpack_public_path__ + "img/valentin.780e4662.jpg";